import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

/**
 * TeamSection Component
 * 
 * Section "Équipe" avec approche radicale:
 * pas de présentation d'équipe traditionnelle.
 */
const TeamSection = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: false, margin: '-20%' });
  
  return (
    <section
      ref={sectionRef}
      className="section-container bg-[#1A1A1A]"
    >
      <div className="max-w-3xl mx-auto text-center">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <p className="text-[#2A3B8F] uppercase tracking-widest text-sm mb-4">
            Qui nous sommes
          </p>
          <h2 className="heading-lg mb-10">
            L'équipe
          </h2>
        </motion.div>
        
        {/* Radical Approach Text */}
        <motion.div
          className="relative"
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          {/* Decorative lines */}
          <motion.div
            className="absolute -left-8 top-0 bottom-0 w-px bg-[#2A3B8F]/30"
            initial={{ scaleY: 0 }}
            animate={isInView ? { scaleY: 1 } : {}}
            transition={{ delay: 0.5, duration: 0.6 }}
          />
          <motion.div
            className="absolute -right-8 top-0 bottom-0 w-px bg-[#2A3B8F]/30"
            initial={{ scaleY: 0 }}
            animate={isInView ? { scaleY: 1 } : {}}
            transition={{ delay: 0.5, duration: 0.6 }}
          />
          
          <motion.p
            className="body-lg text-[#888888] leading-relaxed"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.4 }}
          >
            Notre équipe ne se présente pas. Nos profils LinkedIn ne vous disent pas 
            si nous sommes les bons partenaires pour votre moment décisif.
          </motion.p>
          
          <motion.p
            className="body-lg text-white leading-relaxed mt-6"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.6 }}
          >
            <motion.span
              className="text-[#2A3B8F] font-medium"
              whileHover={{ scale: 1.05 }}
            >
              Rencontrons-nous.
            </motion.span>{' '}
            Parlons de votre défi.
          </motion.p>
          
          <motion.p
            className="body-md text-[#555555] mt-6"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ delay: 0.8 }}
          >
            Vous reconnaîtrez notre expertise dans la pertinence de nos questions 
            et la précision de notre écoute.
          </motion.p>
        </motion.div>
        
        {/* Decorative Element */}
        <motion.div
          className="mt-12 flex justify-center"
          initial={{ opacity: 0, scale: 0 }}
          animate={isInView ? { opacity: 1, scale: 1 } : {}}
          transition={{ delay: 1, type: 'spring' }}
        >
          <motion.div
            className="w-2 h-2 bg-[#2A3B8F] rotate-45"
            animate={{ rotate: [45, 135, 225, 315, 405] }}
            transition={{ duration: 10, repeat: Infinity, ease: 'linear' }}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default TeamSection;
